import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import villa1 from "../../assets/projects/alok-home/1.jpeg";
import apartment1 from "../../assets/projects/purwanchal-noida/1.jpeg";
import odisha from "../../assets/projects/odisha-home/1.jpeg";

const completedProjects = [
  {
    id: 1,
    title: "Alok Home Interior",
    location: "Ranchi",
    image: villa1,
  },
  {
    id: 2,
    title: "Purwanchal Apartment",
    location: "Greater Noida",
    image: apartment1,
  },
  {
    id: 3,
    title: "Odisha House Interior",
    location: "Odisha",
    image: odisha,
  },
];

export default function ProjectsCompleted() {

  const navigate = useNavigate();
  return (
    <section className="py-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-16">

        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-[#2C2C2C] hover:text-[#C9A962] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>

        <h1 className="text-4xl font-serif mb-12 text-center">
          Completed Projects
        </h1>

        <div className="grid md:grid-cols-3 gap-6">
          {completedProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={`/project/${project.id}`}
                className="group block overflow-hidden"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition duration-700"
                />

                <div className="mt-4">
                  <h3 className="font-serif text-xl">
                    {project.title}
                  </h3>

                  <p className="text-gray-500">
                    {project.location}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}